import i18n from '@/plugins/i18n';
import { BYTES_TO_MB_CONVERSION_VALUE } from '@/utils/templates/databaseTemplate/database.constants';
const hardwareMONGOGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.hostCPUUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_cpu_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentagePerMinute'),
      },
      show: true,
      showForSingleSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.memoryUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_memory_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.networkI/O'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_network_bytes_received,meter_mongodb_network_bytes_sent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.connectionsAndSessions'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_connections_active, meter_mongodb_sessions',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
  ],
});

export default hardwareMONGOGraphs;
